import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="tabs-progress"
export default class TabsProgressController extends Controller {
  static targets = ['progressBar'];

  connect() {
    this.updateOnLoad();
  }

  changeTab(event) {
    const tabs = Array.from(event.target.closest('ul').children);
    const index = tabs.indexOf(event.target.closest('li'));

    this.updateProgressBar(index, tabs.length);
  }

  updateProgressBar(index, totalTabs) {
    const progress = ((index + 1) / totalTabs) * 100;
    this.progressBarTarget.style.width = `${progress}%`;
  }

  updateOnLoad() {
    const tabs = Array.from(this.element.querySelectorAll('.nav-item'));
    const activeTab = this.element.querySelector('.nav-link.active');

    if (activeTab) {
      const index = tabs.indexOf(activeTab.closest('li'));
      this.updateProgressBar(index, tabs.length);
    }
  }
}
